import './statusButton.css';

export type ButtonStatusType =
  | 'neutral'
  | 'success'
  | 'failure'
  | 'pending'
  | 'disabled'
  ;

/** a button that indicates status */
export function StatusButton(props: {
  status: ButtonStatusType,
  onClick: () => void,
  children: string,
}) {
  let buttonClass = undefined;
  switch (props.status) {
    case 'neutral': buttonClass = "button-neutral"; break;
    case 'success': buttonClass = "button-success"; break;
    case 'failure': buttonClass = "button-failure"; break;
    case 'pending': buttonClass = "button-pending"; break;
  }
  let buttonStr = props.children;
  switch (props.status) {
    case 'failure': buttonStr += " !"; break;
    case 'pending': buttonStr += " *"; break;
  }
  let disabled = props.status === 'disabled';

  return (
    <button onClick={props.onClick} className={buttonClass} disabled={disabled}>
      {buttonStr}
    </button>);
}
